import React, {FC, memo} from "react";

type SparklineProps = {
    /** Buchungsanzahl je Zeit-Bucket, chronologisch von links nach rechts. */
    values: number[];
    /** Linienfarbe (CSS-Farbe); Standard erbt vom Elternelement via currentColor. */
    stroke?: string;
};

// Vertikales Padding im viewBox, damit die Linie den oberen/unteren Rand nicht berührt.
const V_PADDING = 8;

/**
 * Feine SVG-Sparkline (nur Linie, keine Fläche). Rendert nichts bei < 2 Datenpunkten.
 * Der viewBox ist 100x100 mit `preserveAspectRatio="none"`, sodass sich die Linie auf
 * die tatsächliche Breite/Höhe des Containers streckt; die Strichstärke bleibt dank
 * `vectorEffect="non-scaling-stroke"` optisch konstant.
 */
const Sparkline: FC<SparklineProps> = ({values, stroke = "currentColor"}) => {
    if (!values || values.length < 2) {
        return null;
    }

    const max = Math.max(...values);
    const usableHeight = 100 - 2 * V_PADDING;

    const points = values
        .map((value, index) => {
            const x = (index / (values.length - 1)) * 100;
            // max === 0 → flache Linie am unteren Rand.
            const y = max === 0 ? 100 - V_PADDING : 100 - V_PADDING - (value / max) * usableHeight;
            return `${x},${y}`;
        })
        .join(" ");

    return (
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" width="100%" height="100%">
            <polyline
                points={points}
                fill="none"
                stroke={stroke}
                strokeWidth={1.5}
                strokeLinejoin="round"
                strokeLinecap="round"
                vectorEffect="non-scaling-stroke"
            />
        </svg>
    );
};

export default memo(Sparkline);
